<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 11 14"
    :fill="color"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 0L3.33333 0.666667H0.666667C0.266667 0.666667 0 0.933333 0 1.33333C0 1.73333 0.266667 2 0.666667 2H2H8.66667H10C10.4 2 10.6667 1.73333 10.6667 1.33333C10.6667 0.933333 10.4 0.666667 10 0.666667H7.33333L6.66667 0H4ZM0.666667 3.33333V12C0.666667 12.7333 1.26667 13.3333 2 13.3333H8.66667C9.4 13.3333 10 12.7333 10 12V3.33333H0.666667ZM3.33333 4.66667C3.73333 4.66667 4 4.93333 4 5.33333V11.3333C4 11.7333 3.73333 12 3.33333 12C2.93333 12 2.66667 11.7333 2.66667 11.3333V5.33333C2.66667 4.93333 2.93333 4.66667 3.33333 4.66667ZM7.33333 4.66667C7.73333 4.66667 8 4.93333 8 5.33333V11.3333C8 11.7333 7.73333 12 7.33333 12C6.93333 12 6.66667 11.7333 6.66667 11.3333V5.33333C6.66667 4.93333 6.93333 4.66667 7.33333 4.66667Z"
      fill="#80B7FF"
    />
  </svg>
</template>

<script>
import { colors } from "../../constants";
export default {
  props: {
    width: { type: [Number, String], default: 11 },
    height: { type: [Number, String], default: 14 },
    color: { type: String, default: colors.iconArinet },
  },
};
</script>
